import React from 'react';
import './TermsModal.css';

const TermsModal = ({ onAccept, onDecline }) => {
  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal">
        <h2>Terms and Conditions</h2>
        <div className="terms-content">
          <p>By proceeding, you agree to the following:</p>
          <ul>
            <li>Your facial data will be collected for attendance tracking purposes</li>
            <li>This data will be used to verify your identity when signing in and out of classes</li>
            <li>Your data will be stored securely and only used for educational purposes</li>
            <li>You may request deletion of your facial data at any time</li>
          </ul>
          <p>Do you accept these terms?</p>
        </div>
        <div className="terms-buttons">
          <button onClick={onDecline} className="decline-btn">Decline</button>
          <button onClick={onAccept} className="accept-btn">Accept</button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;